module.exports = __webpack_public_path__ + "img/ico_logo.a19ec4f0.svg";